
import React from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { API_BASE_URL } from '@/config/api';
import { useToast } from '@/hooks/use-toast';

interface DeleteAnalysisModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  analysis?: {
    id: number;
    attributes: {
      subject?: string;
      patient_name?: string;
    };
  };
}

export const DeleteAnalysisModal = ({ isOpen, onClose, onSuccess, analysis }: DeleteAnalysisModalProps) => {
  const { toast } = useToast();

  const confirmDelete = async () => {
    if (!analysis) return;
    
    try {
      const jwt = localStorage.getItem('token');
      
      await axios.delete(`${API_BASE_URL}/analyses/${analysis.id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      });

      toast({
        title: 'Análisis eliminado',
        description: 'El análisis ha sido eliminado exitosamente.',
      });

      console.log(`Eliminando analysis: ${analysis.id}`);
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Error al eliminar el análisis:', error);
      toast({
        title: 'Error',
        description: 'Hubo un error al eliminar el análisis.',
        variant: 'destructive',
      });
    }
  };

  const analysisName = analysis?.attributes.subject || analysis?.attributes.patient_name || 'Sin nombre';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmar Eliminación</DialogTitle>
          <DialogDescription>
            ¿Estás seguro de que quieres eliminar el análisis "{analysisName}"?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button 
            variant="secondary" 
            onClick={onClose} 
            className="bg-gray-200 hover:bg-gray-300 text-black"
          >
            Cancelar
          </Button>
          <Button 
            variant="destructive" 
            onClick={confirmDelete}
          >
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
